import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { IamService } from '../../service';

export type RoleDetailsConfig = typeof RoleDetailsConfig._.Config;

export const RoleDetailsConfig = IntegrationConfig.make({
  service: IamService,
  name: Integration_Handler_Names_Enum.RoleDetails,
  configSchema: z.object({
    roleName: z.string(),
  }),
});
